import type { Board, BoardExpert } from "../board.ts";

let modal: HTMLElement | null = null;

export function closeExperts(): void {
  modal?.remove();
  modal = null;
}

// The "Expertos consultados" roster as a readable modal: names only, with a
// provenance note that individual positions are never published (only the
// aggregate guidance). Opened from the "Ver expertos" proximity button.
// Normalize a roster entry (legacy string or {name, description}) to an object.
function asExpert(e: string | BoardExpert): BoardExpert {
  return typeof e === "string" ? { name: e } : e;
}

export function openExperts(board: Board): void {
  closeExperts();
  const experts = (board.experts ?? []).map(asExpert);
  const count = board.expertCount ?? experts.length;

  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4";
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeExperts();
  });

  const card = document.createElement("div");
  card.className =
    "flex max-h-[90vh] w-full max-w-2xl flex-col gap-3 overflow-auto rounded-2xl border-2 border-black bg-white p-5 shadow-2xl";

  const head = document.createElement("div");
  head.className = "flex items-center gap-3";
  const h = document.createElement("h2");
  h.className = "text-xl font-bold";
  h.textContent = count
    ? `👥 Expertos consultados (${count})`
    : "👥 Expertos consultados";
  const close = document.createElement("button");
  close.className =
    "ml-auto rounded-lg border-2 border-black px-3 py-1 font-bold";
  close.textContent = "Cerrar ✕";
  close.addEventListener("click", closeExperts);
  head.append(h, close);

  const note = document.createElement("p");
  note.className = "text-xs opacity-60";
  note.textContent =
    "Personas consultadas para esta guía. Sus posiciones individuales no se " +
    "publican — solo los resultados agregados por tema.";

  card.append(head, note);

  if (experts.length) {
    const hasBios = experts.some((e) => e.description);
    const grid = document.createElement("ul");
    // Single readable column when bios are present; compact name grid otherwise.
    grid.className = hasBios
      ? "flex flex-col gap-3 text-sm"
      : "columns-2 gap-4 text-sm sm:columns-3";
    for (const expert of experts) {
      const li = document.createElement("li");
      li.className = "mb-1 break-inside-avoid";
      const name = document.createElement("span");
      name.className = "font-semibold";
      name.textContent = expert.name;
      li.appendChild(name);
      if (expert.description) {
        const desc = document.createElement("p");
        desc.className = "text-xs opacity-70";
        desc.textContent = expert.description;
        li.appendChild(desc);
      }
      grid.appendChild(li);
    }
    card.appendChild(grid);
  } else {
    const empty = document.createElement("p");
    empty.className = "text-sm";
    empty.textContent = "Lista en preparación.";
    card.appendChild(empty);
  }

  overlay.appendChild(card);
  document.body.appendChild(overlay);
  modal = overlay;
}
